import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import ReservationsGrid from "../Grid/ReservationsGrid.jsx";
import FilterComponent from "../FilterComponent/FilterComponent.jsx";
import NewFilter from "../NewFilter/NewFilter.jsx";

const Reservations = (props) => {
    const newFilterOn =
        props?.user?.data?.new_filter &&
        props?.user?.data?.new_filter == "true";
    const versionFilter = newFilterOn ? "reservations_new" : "reservations";

    const { mainId } = useParams();
    const location = useLocation();

    // useEffect(() => {
    //     props.reservationsData?.roomTypes || props.getRoomTypes();
    // }, []);

    // const urlParams = new URLSearchParams(window.location.search);
    // const getParamQuotas = {}
    // getParamQuotas.roomTypeId = urlParams.get('room_type_id');
    // getParamQuotas.date_in = urlParams.get('date_in');
    // getParamQuotas.date_out = urlParams.get('date_out');

    let resGrid = <Typography variant={"body1"}>Нет записей </Typography>;

    if (props.reservationsData.loading) {
        resGrid = <LinearProgress mt={4} />;
    } else if (
        !props.reservationsData.loading &&
        props.reservationsData?.AllItems?.length > 0
    ) {
        resGrid = (
            <ReservationsGrid
                getReservations={props.getAllItems}
                editAction={props.editAction}
                resData={props.reservationsData}
                columns={props.columns}
                fields={props.fields}
                paramsChangeHandler={props.paramsChangeHandler}
                getParams={cleanParams(
                    props.globalSearch.search[versionFilter],
                )}
                globalSearch={props.globalSearch}
                updateGlobalSearch={props.updateGlobalSearch}
                versionFilter={versionFilter}
                thisReservationsASU={props?.thisReservationsASU}
            />
        );
    }

    // Выводим  для выбора категории и тарифы, тоько те, которые есть в выведенных бронях
    const roomTypeIdsSet = new Set(
        props.reservationsData.AllItems.map((item) => item.room_type_id),
    );
    const rateIdsSet = new Set(
        props.reservationsData.AllItems.map((item) => item.rate_id),
    );

    const filteredRoomTypes = props?.roomTypes?.filter((roomType) =>
        roomTypeIdsSet.has(roomType.id),
    );

    const filteredRates = props?.rates?.filter((rate) =>
        rateIdsSet.has(rate.id),
    );

    return (
        <Paper elevation={3}>
            <Box p={3}>
                <Typography mb={3} variant={"h5"}>
                    {props.title}
                </Typography>
            </Box>
            {newFilterOn ? (
                <NewFilter
                    initSearch={props.paramsChangeHandler}
                    updateGlobalSearch={props.updateGlobalSearch}
                    globalSearch={props.globalSearch}
                    roomTypes={filteredRoomTypes}
                    hotelId={props.hotelId}
                    setLoading={props.setLoading}
                />
            ) : (
                <FilterComponent
                    pathname={location.pathname}
                    initSearch={props.paramsChangeHandler}
                    roomTypes={filteredRoomTypes}
                    rates={filteredRates}
                    getParams={cleanParams(
                        props.globalSearch.search.reservations,
                    )}
                    globalSearch={props.globalSearch}
                    updateGlobalSearch={props.updateGlobalSearch}
                    user={props.user}
                    inputFilter={props?.inputFilter}
                />
            )}
            <Box mt={4}>{resGrid}</Box>
        </Paper>
    );
};

Reservations.defaultProps = {
    reservationsData: {
        AllItems: [],
        AuxItems: [],
        currentItem: null,
        error: null,
    },
    columns: [
        { id: "id", label: "id" },
        { id: "guestName", label: "Гость" },
        { id: "created_at", label: "Дата создания" },
        { id: "date_in", label: "Дата заезда" },
        { id: "date_out", label: "Дата выезда" },
        { id: "number", label: "Номер бронирования" },
        { id: "status", label: "Статус" },
        { id: "order_source", label: "Источник заказа" },
        { id: "control", label: "Управление" },
        { id: "roomName", label: "Категория номера" },
        { id: "rateName", label: "Тариф" },
        { id: "order_number", label: "Номер заказа" },
        { id: "total", label: "Сумма" },
        { id: "promo_code", label: "Промокод" },
        { id: "status_pms", label: "Статус PMS" },
    ],
};

Reservations.propTypes = {
    columns: PropTypes.array,
    title: PropTypes.string.isRequired,
    editAction: PropTypes.func.isRequired,
    getAllItems: PropTypes.func.isRequired,
    reservationsData: PropTypes.object.isRequired,
    fields: PropTypes.object,
    getRoomTypes: PropTypes.func,
    getParams: PropTypes.object,
    paramsChangeHandler: PropTypes.func,
};

export default Reservations;

const cleanParams = (obj) => {
    const newParams = {};
    for (const key in obj) {
        if (obj[key] !== "") {
            newParams[key] = obj[key];
        }
    }
    return newParams;
};
